import { defineComponent as _defineComponent } from 'vue'
import {
    contactStatuses,
    StatusFiltersLabels,
    StatusFiltersValues,
  } from "@/constants/statusFilters";
  import { computed, onMounted, ref, watch } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import CheckboxInput from "@/components/ui/input/CheckboxInput.vue";
  import ContactStatusBadge from "@/components/ui/ContactStatusBadge.vue";
  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import ExportContactsModal from "@/components/ui/modals/ExportContactsModal.vue";
  import router from "@/router";
  import store from "@/store";
  import { ContactInterface } from "@/types/ContactInterface";
  import { contactStatus } from "@/helpers/contactStatus";
  import { getContactStatusClass } from "@/helpers/status";
  import { ContactStatus } from "@/enums/ContactStatus";
  import plural from "@/features/plural";
  import { debounce } from "@/helpers/debounce";
  import { EstateInterface } from "@/types/EstateInterface";
  import { useRequest } from "@/features/useRequest";
  import { POSITION } from "vue-toastification";
  import { EstateActions } from "@/store/modules/estate";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsView',
  setup(__props, { expose: __expose }) {
  __expose();

  const filters = contactStatuses;
  const activeFilter = ref(contactStatuses[0]);
  const isExportModalOpen = ref(false);

  function openExportModal() {
    isExportModalOpen.value = true;
  }
  function closeExportModal() {
    isExportModalOpen.value = false;
  }

  const searchQuery = ref("");
  const debounceSearch = debounce(getContacts);
  const estate = ref<EstateInterface | null>(null);
  const estateHasCollaborators = computed(() => {
    const collaboratorsLength = estate.value?.collaboratorBusiness?.length;

    return collaboratorsLength && collaboratorsLength > 0;
  });
  const titles = computed(() => {
    const headers = [
      {
        text: "Name",
      },
      {
        text: "Postcode",
      },
      {
        text: "Email",
      },
      {
        text: "Phone Number",
      },
      {
        text: "Contact Status",
      },
    ];

    if (estateHasCollaborators.value) {
      headers.push({
        text: "Business",
      });
    }

    return headers;
  });

  function onRow(id: string) {
    router.push(`/contacts/${id}`);
  }

  function changeFilter(item: {
    label: StatusFiltersLabels;
    value: StatusFiltersValues;
  }) {
    activeFilter.value = item;
    getContacts();
  }

  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });

  const getEstate = async () => {
    const { handleRequestWithLoading } = useRequest(
      undefined,
      undefined,
      POSITION.TOP_LEFT
    );
    const res = await handleRequestWithLoading<EstateInterface, string>(
      EstateActions.GET_ESTATE,
      estateId.value,
      loading
    );

    estate.value = res?.data;
  };

  const contactlist = ref<ContactInterface[]>([]);

  onMounted(() => {
    getContacts();
    getEstate();
  });

  const loading = ref(false);

  function getContacts() {
    if (estateId.value) {
      loading.value = true;
      store
        .dispatch("contact/getContacts", {
          id: estateId.value,
          buyerStatus:
            activeFilter.value.value === StatusFiltersValues.ANY
              ? ""
              : activeFilter.value.value,
          searchKey: searchQuery.value,
        })
        .then((res) => {
          contactlist.value = res.data;
        })
        .finally(() => {
          loading.value = false;
        });
    }
  }

  watch(
    () => estateId.value,
    () => {
      getContacts();
    }
  );
  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );

const __returned__ = { filters, activeFilter, isExportModalOpen, openExportModal, closeExportModal, searchQuery, debounceSearch, estate, estateHasCollaborators, titles, onRow, changeFilter, estateId, getEstate, contactlist, loading, getContacts, get contactStatuses() { return contactStatuses }, get StatusFiltersLabels() { return StatusFiltersLabels }, get StatusFiltersValues() { return StatusFiltersValues }, computed, onMounted, ref, watch, DropDown, CheckboxInput, ContactStatusBadge, InputSearch, ExportContactsModal, get router() { return router }, get store() { return store }, get ContactInterface() { return ContactInterface }, get contactStatus() { return contactStatus }, get getContactStatusClass() { return getContactStatusClass }, get ContactStatus() { return ContactStatus }, get plural() { return plural }, get debounce() { return debounce }, get EstateInterface() { return EstateInterface }, get useRequest() { return useRequest }, get POSITION() { return POSITION }, get EstateActions() { return EstateActions } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})